export const PARTNER_STATUSES = ["active", "paused"] as const;
export type PartnerStatus = (typeof PARTNER_STATUSES)[number];

export const PROMO_DISCOUNT_TYPES = ["percent", "fixed"] as const;
export type PromoDiscountType = (typeof PROMO_DISCOUNT_TYPES)[number];

export const PROMO_STATUSES = ["active", "disabled"] as const;
export type PromoStatus = (typeof PROMO_STATUSES)[number];

export const REFERRAL_SOURCES = ["link", "promo"] as const;
export type ReferralSource = (typeof REFERRAL_SOURCES)[number];

export const PAYMENT_DISCOUNT_SOURCES = ["referral", "promo"] as const;
export type PaymentDiscountSource = (typeof PAYMENT_DISCOUNT_SOURCES)[number];

export const COMMISSION_STATUSES = ["active", "reversed"] as const;
export type CommissionStatus = (typeof COMMISSION_STATUSES)[number];

export const COMMISSION_TYPES = ["payment", "adjustment"] as const;
export type CommissionType = (typeof COMMISSION_TYPES)[number];

export const AUTH_ROLES = ["admin", "partner"] as const;
export type AuthRole = (typeof AUTH_ROLES)[number];
